import { useActiveEntities as d } from "../../../store/active-entities.js";
import { specDictionary as f } from "../../../store/import-spec.js";
import { combineRenameDiffs as D, mutateCollectionDiff as R, mutateSecuritySchemeDiff as g, mutateServerDiff as S, mutateTagDiff as T, mutateRequestDiff as M } from "../libs/watch-mode.js";
import { fetchDocument as I, createHash as C } from "@scalar/oas-utils/helpers";
import { parseSchema as O } from "@scalar/oas-utils/transforms";
import { useToasts as L } from "@scalar/use-toasts";
import { useTimeoutPoll as N } from "@vueuse/core";
import U from "microdiff";
import { watch as b } from "vue";
import { useWorkspace as P } from "../../../store/store.js";
const k = 5 * 1e3, q = 60 * 1e3, J = () => {
  const { toast: h } = L(), c = d(), o = P(), { activeCollection: s, activeWorkspace: W } = c, { collectionMutators: n } = o, i = (e) => h(`[useOpenApiWatcher] Changes to the ${e} were not applied`, "error"), w = (e) => {
    e.path[0] === "info" || e.path[0] === "security" ? R(e, c, o) || i("collection") : e.path[0] === "components" && e.path[1] === "securitySchemes" ? g(e, c, o) || i("securitySchemes") : e.path[0] === "servers" ? S(e, c, o) || i("servers") : e.path[0] === "tags" ? T(e, c, o) || i("tags") : e.path[0] === "paths" && (M(e, c, o) || i("requests"));
  }, { pause: p, resume: m } = N(async () => {
    var l, v;
    const e = (l = s.value) == null ? void 0 : l.documentUrl;
    if (!e)
      return;
    const t = f[e];
    try {
      const a = await I(e, (v = W.value) == null ? void 0 : v.proxyUrl, void 0, !1), u = C(a);
      if (n.edit(s.value.uid, "watchModeStatus", "WATCHING"), t != null && t.hash)
        if (t.hash && t.hash !== u) {
          const { schema: r } = await O(a), A = U(t.schema, r), y = D(A);
          try {
            y.forEach(w), f[e] = {
              hash: u,
              schema: r
            };
          } catch (E) {
            console.error("[useOpenApiWatcher] Error:", E);
          }
        } else
          console.log("[useOpenApiWatcher] No changes detected yet…");
      else {
        const { schema: r } = await O(a);
        r && (f[e] = {
          hash: u,
          schema: r
        });
      }
    } catch (a) {
      console.error("[useOpenApiWatcher] Error:", a), console.info("[useOpenApiWatcher] Pausing watcher for 60 seconds"), p(), n.edit(s.value.uid, "watchModeStatus", "ERROR"), h("[useOpenApiWatcher] Unable to fetch the spec file, paused the watcher for 60 seconds", "error"), setTimeout(() => {
        console.info("[useOpenApiWatcher] Resuming watcher"), m();
      }, q);
    }
  }, k);
  b(
    [() => {
      var e;
      return (e = s.value) == null ? void 0 : e.documentUrl;
    }, () => {
      var e;
      return (e = s.value) == null ? void 0 : e.watchMode;
    }],
    ([e, t]) => {
      e && t ? (console.info(`[useOpenApiWatcher] Watching ${e} …`), m()) : s.value && (p(), n.edit(s.value.uid, "watchModeStatus", "IDLE"));
    },
    { immediate: !0 }
  );
};
export {
  J as useOpenApiWatcher
};
